import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aef9e3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "use-restricted"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.shouldShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "block-release-date",
          innerHTML: $setup.DOMPurify.sanitize($props.displayHTMLText)
        }, null, 8 /* PROPS */, _hoisted_2)
      ]))
    : _createCommentVNode("v-if", true)
}